<template>

    <modal-container class="modal-container--short">

        <!-- Top navbar -->
        <modal-header
            :title="''"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <!-- Prompt content -->
        <prompt-div>

            <!-- Layout body -->
            <template v-slot:body>
                <img class="m-3" src="/images/illustration-cash-exists.svg">

                <h3 class="font-weight-bolder font-xl">You have an unfinished application</h3>

                <div v-if="forPos">
                    <div class="d-flex justify-content-center text-dark-grey mb-6">Please finish your application to get this product from the Marketplace!<br>Don't worry, you can pick up where you left off at your convenience.</div>
                    <div>
                        <button v-if="$store.state.session.posClaimingCompatible" class="btn btn-primary w-100 font-lg" @click="claimForMpl()">Buy this item</button>
                        <button v-else class="btn btn-primary w-100 font-lg" @click="exit('dashboard')">Resume existing application</button>
                        <div class="text-green p-3 font-weight-bolder" @click="mplHome()">Explore Marketplace</div>
                    </div>
                </div>

                <div v-if="forXcl">
                    <div class="d-flex justify-content-center text-dark-grey mb-6">You still haven't finished your application. Don't you worry you can continue where you left off.</div>
                    <div>
                        <button class="btn btn-primary w-100 font-lg" @click="exit('dashboard')">Resume existing application</button>
                        <div class="text-green p-3 font-weight-bolder" @click="mplHome()">Explore Marketplace</div>
                    </div>
                </div>
            </template>
        </prompt-div>
    </modal-container>

</template>

<script>
    import productMixin from '../../components/productMixin'

    export default {
        mixins: [productMixin],
        computed: {
            forPos: function() {
                return (this.$store.state.session.tagDescription === 'unfinished_pos')
            },
            forXcl: function() {
                return (this.$store.state.session.tagDescription === 'unfinished_xcl')
            }
        },
        methods: {
          exit: function(loc) {
            // analytics

            let params = new URLSearchParams({
                location: loc
            });

            window.location.replace("/exit?" + params.toString())
          },
          claimForMpl: function() {
                // analytics
                if (!this.$store.state.session.genPosCompatible) {
                    this.$root.openModal('modal_situation', {
                        shortText: 'Your installment shopping is just one update away...',
                        longText: 'We are inviting you to shop with us! We just need you to update your app to the latest version so you can enjoy shopping in our Marketplace.'
                    })
                } else {
                    this.startCheckoutProcess({productId: this.productForCheckout, source: this.$root.modalParams.source, gposClaiming: true})
                }

            },
          mplHome: function() {
            // analytics

            this.$router.push({name:'home'})
          }
        },
        created: function() {
            // set product being checked out
            this.productForCheckout = this.$root.modalParams.productForCheckout

            // analytics
        }
    }
</script>

<style scoped>
.prompt-container {
    margin: 0 2.8rem 1rem 2.8rem; /** override for text wrap **/
}
</style>
